<template>
    <div class="OrderDetails">
        <Header></Header>
        <div style="width: 1000px;overflow: hidden;overflow-y: auto;scrollbar-width: none; " :style="{
            'margin-left': innerWidth > 1000 ? (innerWidth - 1000) / 2 + 'px' : '0px',
            'height': (innerHeight - 70 - 68) + 'px'
        }">

            <div class="order">
                <div class="title">收货地址：</div>
                <ul class="address_list">
                    <li :class="[address.isDefault ? 'default' : '', address.addressId == chooseAddress.addressId? 'active' : '' ]"
                         v-for="(address, index) in addressList" :key="index" @click="switchoverAddress(address)">
                        <div class="nameWrap"><span class="name">{{address.receiveName}}</span> <span class="tel">{{address.receivePhone}}</span></div>
                        <div class="address"><span class="">{{address.provinceName}}</span> <span class="">{{address.cityName}}</span> <span
                                class="">{{address.areaName}}</span>
                            {{address.detailedAddress}}
                        </div>
                        <div v-if="address.addressId == chooseAddress.addressId" class="edit" @click="editAddress(address)">
                            编辑
                        </div>
                    </li>
                    <li class="addNew" v-if="addressList.length<3" @click="showAddress"><i class="iconAdd"></i><span>添加收货地址</span></li>
                </ul>
                <div class="title">商品信息：</div> 
                <div class="good_wrap">
                    <div class="good_det">
                        <div>
                            <img :src="goodInfo.photos[0].url"
                                alt="私教密训班" onerror="this.src='/static/img/default-bg.56f083dd.png'">
                            <div class="good_Info">
                                <div style="font-size: 18px;line-height: 22px;font-weight: 600; white-space: nowrap;">{{goodInfo.goodsName}}</div>
                                <div class="sub_title">
                                    {{goodInfo.chooseSpec.specAttribute}}
                                </div>
                                <div style="color:#F56C6C">
                                    <span class="unit">￥</span><span class="origin">{{(goodInfo.chooseSpec.price/100).toFixed(2)}}</span>
                                    <el-button style="float: right;" type="danger" @click="createOrder" >立即购买</el-button>
                                </div>
                           
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>

        <el-dialog title="添加地址" :visible.sync="addressVisible" width="600px">
            <el-form ref="form" label-width="130px">
                <el-form-item label="选择区域" required>
                    <el-cascader style="width: 350px;" v-model="regionValue" placeholder="选择区域"
                        :props="{ checkStrictly: true }" :options="regionTree" @change="handleChange" filterable
                        clearable></el-cascader>
                </el-form-item>
                <el-form-item label="收件详细地址" required>
                    <el-input type="textarea" style="width: 350px;" v-model="addressInfo.detailedAddress"></el-input>
                </el-form-item>
                <el-form-item label="收件人名" required>
                    <el-input v-model="addressInfo.receiveName" clearable style="width: 350px;"></el-input>
                </el-form-item>
                <el-form-item label="收件手机号" required>
                    <el-input v-model="addressInfo.receivePhone" maxlength="11" show-word-limit="11" minlength="1"
                        clearable style="width: 350px;"></el-input>
                </el-form-item>
                <el-form-item label="是否默认地址">
                    <el-radio v-model="addressInfo.isDefault" :label="1">是</el-radio>
                    <el-radio v-model="addressInfo.isDefault" :label="0">否</el-radio>
                </el-form-item>

                <div style="text-align: center;margin-top: 15px;">
                    <el-button @click="verificationVisible = false">返回</el-button>
                    <el-button type="primary" @click="saveEditAddress">确定</el-button>
                </div>
            </el-form>
        </el-dialog>

        <Suspension></Suspension>
        <Footer></Footer>

    </div>



</template>


<script>
import Header from "../../components/common/Header"
import Footer from "../../components/common/Footer"
import Suspension from "../../components/common/Suspension"

import {
    getByUrl,
    sendPostRqeByJSON
} from '@/api/api.js';


import {
    getLocalStorage
} from '@/utils/util.js';



export default {
    name: "OrderDetails",
    components: {
        Header,
        Footer,
        Suspension
    },
    data() {
        return {
            chooseAddress:{},
            regionValue: [],
            addressList: [],
            goodInfo:{},
            addressInfo: {
                addressId: '',
                areaId: '',
                provinceId: '',
                cityId: '',
                detailedAddress: '',
                isDefault: 0,
                receiveName: '',
                receivePhone: '',
            },
            regionTree: [],
            addressVisible: false,
            innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        }
    },

    mounted() {
        console.log(JSON.parse(getLocalStorage('goodInfo')) )
        
        this.goodInfo = JSON.parse(getLocalStorage('goodInfo'))
        this.getRegionTree()
        this.getAddressList()
    },
    methods: {
        createOrder(){
            let params = {
                addressId:this.chooseAddress.addressId,
                remark:this.chooseAddress.receiveName,
                orderInfos:[
                    {
                        goodsId:this.goodInfo.goodsId,
                        specId:this.goodInfo.chooseSpec.specId,
                        num:1,
                    }
                ]
            }
            sendPostRqeByJSON(params,'/web/orders/create').then(res=>{
                console.log(res)
                if(res.code == 200){
                    this.$router.push({
                        path: '/order/pay',
                        query: {
                            ordersId:res.data
                        }
                    })
                }else{
                    this.$message({
                        message: res.message,
                        type: 'error',
                        duration: 1000
                    });
                }
            })

        },
        switchoverAddress(item){
            this.chooseAddress = item
        },
        editAddress(item){
            this.addressInfo = item
            this.regionValue = [item.provinceId, item.cityId, item.areaId]
            this.addressVisible = true
        },
        getAddressList() {
            this.addressList = []
            getByUrl('/web/address/list').then(res => {
                console.log(res)
                for(let i=0;i<res.data.length;i++){
                    if(i<=2){
                        this.addressList.push(res.data[i])
                    }
                }
                this.chooseAddress = res.data[0]
            })
        },
        saveEditAddress() {
            if (this.regionValue.length == 0) {
                this.$message.error('请选择区域');
                return;
            }

            if (!this.addressInfo.detailedAddress) {
                this.$message.error('请填写详细地址');
                return;
            }

            if (!this.addressInfo.receiveName) {
                this.$message.error('请填写收件人名');
                return;
            }

            if (!this.addressInfo.receivePhone) {
                this.$message.error('请填写收件手机号');
                return;
            }

            this.addressInfo.provinceId = this.regionValue[0] ? this.regionValue[0] : ''
            this.addressInfo.cityId = this.regionValue[1] ? this.regionValue[1] : ''
            this.addressInfo.areaId = this.regionValue[2] ? this.regionValue[2] : ''


            var url = '/web/address/save'
            if (this.addressInfo.addressId) {
                url = '/web/address/update'
            }

            sendPostRqeByJSON(this.addressInfo, url).then(res => {
                if (res.code == 200) {
                    this.addressVisible = false
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.getAddressList()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        handleChange() { },
        getRegionTree() {
            console.log("getRegionTree")
            sendPostRqeByJSON({}, "/web/region/tree").then(res => {
                this.regionTree = res.data
            })
        },
        showAddress() {
            this.addressVisible = true
        },
    },
}
</script>
<style scoped>
.order {
    width: 1000px;
    margin: 0 auto;
    padding-top: 40px;
}

.title {
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
    margin-top: 30px;
}

.address_list {
    margin-top: 10px;
    clear: both;
    height: 120px;
}

.active {
    background-color: rgba(5, 193, 183, .06);
    box-shadow: 0 4px 16px -6px rgba(44, 217, 208, .3);
    border: 1px solid #409EFF;
}

.address {
    color: #737780;
    font-size: 12px;
    line-height: 18px;
    margin-top: 6px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
    -ms-text-overflow: ellipsis;
    text-overflow: ellipsis;
    overflow: hidden;
}

.edit {
    color: #409EFF;
    font-size: 12px;
    line-height: 1;
    position: absolute;
    right: 10px;
    bottom: 6px;
}


li {
    width: 250px;
    min-height: 96px;
    border-radius: 8px;
    margin-left: 20px;
    border: 1px solid #ededed;
    background: url('../../../static/image/address_icon.png') no-repeat 6px 10px;
    background-size: 24px;
    padding: 14px 16px 16px 36px;
    float: left;
    cursor: pointer;
    position: relative;
}

li.default:before {
    display: block;
    content: "默认地址";
    position: absolute;
    right: -1px;
    top: -1px;
    width: 60px;
    background: #409EFF;
    border-radius: 0 8px 0 8px;
    font-size: 12px;
    color: #fff;
    text-align: center;
    line-height: 16px;
}

li .nameWrap {
    line-height: 18px;
}

.title {
    clear: both;
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
    margin-top: 30px;
}
.good_wrap {
    /* background: #fff; */
    box-shadow: 0 1px 10 -2px rgba(0,0,0,.04);
    border-radius: 8px;
    border: 1px solid #ededed;
    padding: 0 20px;
    margin: 10px auto 0;
}
.good_det{
    position: relative;
    margin: 20px 0;
}
.good_det img {
    display: inline-block;
    width: 114px;
    height: 114px;
    border-radius: 12px;
}
.good_Info {
    width: 826px;
    float: right;
}
.sub_title {
    max-width: 780px;
    display: inline-block;
    background: #f7f7f7;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    padding: 4px 8px;
    line-height: 15px;
    font-size: 12px;
    color: #7f7f7f;
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>